import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '界面事件能力',
    type: 'UI_UE',
}
